export default "__VITE_ASSET__CWEfM9dD__"